<!--
<section class="title-bar content-padding first-item">
  <div class="wrapper nowrap">
    <h2 class="title-heading">{{product?.id ? "Modifica" : "Nuovo"}} prodotto</h2>
    <div class="item nowrap">
      <span class="data-row-left btn-container top-button-container">
        <button class="btn btn-red vertical align-items-center" (click)="delete()" *ngIf="product?.id && groups.includes('admin')">
          Elimina<i class="ml-10 fas fa-plus"></i>
        </button>
      </span>
    </div>
  </div>
</section>
-->

<section class="main-content wrapper content-padding " style="margin-top: 50px;">
  <div class="content-panel">
    <div class="tabs">
      <label class="tab">
        <a class="tab-link active-tab">{{product?.id ? "Modifica" : "Nuovo"}} prodotto</a>
      </label>
    </div>

    <div class="button-wrapper">
      <button class="btn btn-red vertical align-items-center" (click)="delete()" *ngIf="product?.id && groups.includes('admin')">
        Elimina<i class="ml-10 fas fa-trash"></i>
      </button>
    </div>

    <section class="content-padding darker">
      <div class="narrow-wrapper">
        <form class="has-cols product-form" [formGroup]="_productForm" (ngSubmit)="onSubmit()" *ngIf="_productForm">

          <div class="product-info-box">
            <fieldset>
              <legend>DETTAGLI DEL PRODOTTO:</legend>
              <div class="col-50 grid-element">
                <label for="name">Nome{{ _productForm.get("name") | required }}</label>
                <input type="text" name="name" formControlName="name">
                <app-error-html-handler [ctrl]="_productForm.get('name')" [messages]="formValidationMsgs.name">
                </app-error-html-handler>
              </div>
              <!-- old category
              <div class="col-50 grid-element">
                <label for="category">Categoria{{ _productForm.get("category") | required }}</label>
                <input type="text" name="category" formControlName="category">
                <app-error-html-handler [ctrl]="_productForm.get('category')" [messages]="formValidationMsgs.category">
                </app-error-html-handler>
                <div style="font-size: smaller;">Ogni elemento è separato da ; (punto e virgola).</div>
              </div>
              <!-- old category -->

              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('teamleader')">
                <label for="sku">Partners</label>
                <select formControlName="partner" (change)="handlePartnerChange($event.target.value)">
                  <option disabled selected>Select Any Partner</option>
                  <option *ngFor="let partner of partners" [value]="partner?.id"> {{partner.businessName}}</option>
                </select>
              </div>
        
              <div class="col-50 grid-element">
                <label for="category">Prodotto Categoria{{ _productForm.get("productCategory") | required }}</label>
                <ng-select 
                  class="product-category"
                  [multiple]="false" 
                  [hideSelected]="true"
                  [closeOnSelect]="true"
                  formControlName="productCategory"
                  (change)="handleProductCategoryChange($event)"
                  >
                  <ng-option *ngFor="let productCategory of productCategories" [value]="productCategory.id">
                    {{ productCategory?.categoryName }}
                  </ng-option>
                </ng-select>
                <app-error-html-handler [ctrl]="_productForm.get('productCategory')" [messages]="formValidationMsgs.productCategory">
                </app-error-html-handler>
              </div>

              <div class="product-info-box" *ngIf="productCategoryMetaFields.length > 0">
                <br class="clear">
                <fieldset>
                  <legend>CAMPI ANAGRAFICI:</legend>
                  <div class="base">
                    <span *ngIf="aiButtonDisable">
                      <div *ngFor="let i of [].constructor(15); let index = index" [ngClass]="'circ circ-' + (index + 1)"></div>
                    </span>
                    <div>
                      <button type="button" *ngIf="!aiButtonDisable" class="btn hvr-shrink center" (click)="generateTextWithAi()">Generate With AI</button>
                    </div>
                  </div>
                  <div formArrayName="productCategoryMetaFields">
                    <div class="col-100 grid-element" *ngFor="let field of productCategoryMetaFields; let i = index">
                      <label>{{ field.fieldName }} {{ (field.type === '1' || ( (field.type === '3') && ( groups.includes('admin') || groups.includes('operation') ) ) ) ? "*" : '' }}</label>
                      <textarea [formControlName]="i" rows="5"></textarea>
                      <app-error-html-handler 
                        [ctrl]="metaFields.controls[i]" 
                        [messages]="formValidationMsgs[field.fieldName]">
                      </app-error-html-handler>
                    </div>
                  </div>
                </fieldset>
              </div>
              
        
              <div class="col-50 grid-element">
                <label for="sku">SKU</label>
                <input type="text" name="sku" formControlName="sku">
                <app-error-html-handler [ctrl]="_productForm.get('sku')" [messages]="formValidationMsgs.sku"></app-error-html-handler>
              </div>

              <div class="col-50 grid-element">
                <label for="ggDispMin">Giorni Preparazione{{ _productForm.get("ggDispMin") | required }}</label>
                <input type="number" name="ggDispMin" formControlName="ggDispMin">
                <app-error-html-handler [ctrl]="_productForm.get('ggDispMin')" [messages]="formValidationMsgs.ggDispMin"></app-error-html-handler>
              </div>
        
              <div class="col-100 grid-element">
                <label for="productAdvantageDesc">PLUS DEL PRODOTTO (max 80 caratteri){{ _productForm.get("productAdvantageDesc") | required }}</label>
                <textarea formControlName="productAdvantageDesc" rows="2" placeholder="Scrivi una descrizione"></textarea>
                <app-error-html-handler [ctrl]="_productForm.get('productAdvantageDesc')" [messages]="formValidationMsgs.productAdvantageDesc"></app-error-html-handler>
              </div>

              <div class="col-100 grid-element">
                <label for="description">Descrizione{{ _productForm.get("description") | required }}</label>
                <textarea formControlName="description" rows="5" placeholder="Scrivi una descrizione"></textarea>
              </div>
              
              <div class="col-50 grid-element">
                <label for="price">Prezzo{{ _productForm.get("price") | required }}</label>
                <input type="number" min="0" name="price" formControlName="price">
                <app-error-html-handler [ctrl]="_productForm.get('price')" [messages]="formValidationMsgs.price">
                </app-error-html-handler>
              </div>
        
              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label for="price">Prezzo pubblico{{ _productForm.get("shopifyPrice") | required }}</label>
                <input type="number" min="0" name="shopifyPrice" formControlName="shopifyPrice">
                <app-error-html-handler [ctrl]="_productForm.get('shopifyPrice')" [messages]="formValidationMsgs.shopifyPrice"></app-error-html-handler>
              </div>
        
              <div class="col-50 grid-element">
                <label for="line">Linea{{ _productForm.get("line") | required }}</label>
                <input type="text" name="line" formControlName="line">
                <app-error-html-handler [ctrl]="_productForm.get('line')" [messages]="formValidationMsgs.line">
                </app-error-html-handler>
                <div style="font-size: smaller;">Ogni elemento è separato da ; (punto e virgola).</div>
              </div>
              
              <!--
              <div class="col-50 grid-element">
                <label for="stock">Stock{{ _productForm.get("stock") | required }}</label>
                <input type="text" name="stock" formControlName="stock">
                <app-error-html-handler [ctrl]="_productForm.get('stock')" [messages]="formValidationMsgs.stock">
                </app-error-html-handler>
                <div style="font-size: smaller;">Ogni elemento è separato da ; (punto e virgola).</div>
              </div>
              -->
        
              <!-- <div class="col-50 grid-element">
                <label for="quantity">QUANTITY</label>
                <input type="text" name="quantity" formControlName="quantity">
                <app-error-html-handler [ctrl]="_productForm.get('quantity')" [messages]="formValidationMsgs.quantity">
                </app-error-html-handler>
              </div> -->
        
              <div class="col-50 grid-element">
                <label for="image">Immagine{{ _productForm.get("image") | required }}</label>
                <div *ngIf="product?.image && !removeFile">
                  <a style="float: right; width: auto; color: red; cursor: pointer;" (click)="deleteFile();">×</a>
                  <!-- <img [src]="product.id | productImage | async" class="img-prodotto" style="max-height: 100px; cursor: pointer;" (click)="openImage($event)" /> -->
                  <img [src]="imagePath" class="img-prodotto" style="max-height: 100px; cursor: pointer;" (click)="openImage(imagePath)" />
                </div>
                <input type="file" name="image" (change)="onFileSelect($event)" />
                <app-error-html-handler [ctrl]="_productForm.get('image')" [messages]="formValidationMsgs.image">
                </app-error-html-handler>
              </div>

              <!--
              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="inStock" formControlName="inStock">
                  DISPONIBILE
                </label>
              </div> 
              -->

              <!--
              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="adminApproval" formControlName="adminApproval">
                  APPROVATO
                </label>
              </div> 
              -->

              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="unEditable" formControlName="unEditable">
                  NON MODIFICABILE
                </label>
              </div> 
              
              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="uniqueProduct" formControlName="uniqueProduct">
                  PRODOTTO UNICO
                </label>
              </div> 

              <!-- <fieldset style="margin-top: 20px;" *ngIf="groups.includes('admin') || groups.includes('operation')"> -->
              <fieldset style="margin-top: 20px;">
                <legend>INVENTORY MANAGEMENT</legend>

                <div class="col-50 grid-element">
                  <label class="original-label" for="controlStock">
                    <input type="checkbox" name="controlStock" id="controlStock" formControlName="controlStock">
                    CONTROLLA STOCK
                  </label>
                </div> 

                <br class="clear">

                <div class="col-50 grid-element" *ngIf="_productForm.get('controlStock').value === true" style="margin-top: 20px;">
                  <label for="stock">INVENTARIO{{ _productForm.get("productAvailability") | required }}</label>
                  <input type="number" name="stock" formControlName="productAvailability">
                  <app-error-html-handler [ctrl]="_productForm.get('productAvailability')" [messages]="formValidationMsgs.productAvailability"></app-error-html-handler>
                </div>

              </fieldset>
              
              <fieldset style="margin-top: 20px;">
                <legend>Nome alternativo del prodotto</legend>

                <div class="col-50 grid-element">
                  <label class="original-label" for="isAlternateProductName">
                    <input type="checkbox" name="isAlternateProductName" id="isAlternateProductName" formControlName="isAlternateProductName">
                    Usa nome alternativo del prodotto
                  </label>
                </div> 

                <br class="clear">

                <div class="col-50 grid-element" *ngIf="_productForm.get('isAlternateProductName').value === true" style="margin-top: 20px;">
                  <label for="alternateProductName">Nome alternativo del prodotto{{ _productForm.get("alternateProductName") | required }}</label>
                  <input type="text" name="alternateProductName" formControlName="alternateProductName">
                  <app-error-html-handler [ctrl]="_productForm.get('alternateProductName')" [messages]="formValidationMsgs.alternateProductName"></app-error-html-handler>
                </div>

              </fieldset>
            
            </fieldset>
          </div>

          <br class="clear">

          <div class="products-shopify-connection-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <fieldset>
              <legend>SHOPIFY CONNECTION:</legend>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="adminApproval" formControlName="adminApproval">
                  APPROVATO
                </label>
              </div> 

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="productStatus" formControlName="productStatus">
                  PRODUCT <b>[ {{ _productForm.get('productStatus').value ? "Attivo" : "Disattivo" }} ]</b>
                </label>
              </div> 
              
              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="notPhysical" formControlName="notPhysical">
                  NOT PHYSICAL
                </label>
              </div>
              <br class="clear">

              <fieldset style="margin-top: 20px;">
                <legend>SELECT PLATFORMS</legend>
                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isDeluxyProduct" formControlName="isDeluxyProduct" (change)="handleShopCheckbox($event, 'deluxy')">
                    DELUXY <b>[deluxy.it]</b>
                  </label>
                </div>

                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyProduct').value}" style="margin-top: 20px;">
                  <label for="deluxyDescription">DELUXY DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('deluxyDescription')" [messages]="formValidationMsgs.deluxyDescription"></app-error-html-handler>
                </div>

                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isCakeProduct" formControlName="isCakeProduct" (change)="handleShopCheckbox($event, 'cake')">
                    CAKEDESIGN <b>[cakedesign.me]</b>
                  </label>
                </div>
                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isCakeProduct').value}" style="margin-top: 20px;">
                  <label for="cakeDescription">CAKEDESIGN DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="cakeDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('cakeDescription')" [messages]="formValidationMsgs.cakeDescription"></app-error-html-handler>
                </div>
                <br class="clear">

                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isFlowersProduct" formControlName="isFlowersProduct" (change)="handleShopCheckbox($event, 'flowers')">
                    FLOWERS <b>[deluxyflowers.com]</b>
                  </label>
                </div>
                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isFlowersProduct').value}" style="margin-top: 20px;">
                  <label for="flowersDescription">FLOWERS DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="flowersDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('flowersDescription')" [messages]="formValidationMsgs.flowersDescription"></app-error-html-handler>
                </div>

                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isBusinessProduct" formControlName="isBusinessProduct" (change)="handleShopCheckbox($event, 'business')">
                    BUSINESS <b>[business.deluxy.it]</b>
                  </label>
                </div>
                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isBusinessProduct').value}" style="margin-top: 20px;">
                  <label for="businessDescription">BUSINESS DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="businessDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('businessDescription')" [messages]="formValidationMsgs.businessDescription"></app-error-html-handler>
                </div>

                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isDeluxyExperienceProduct" formControlName="isDeluxyExperienceProduct" (change)="handleShopCheckbox($event, 'deluxyExperience')">
                    DELUXY EXPERIENCE <b>[deluxyexperience.it]</b>
                  </label>
                </div>
                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyExperienceProduct').value}" style="margin-top: 20px;">
                  <label for="deluxyExperienceDescription">DELUXY EXPERIENCE DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyExperienceDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('deluxyExperienceDescription')" [messages]="formValidationMsgs.deluxyExperienceDescription"></app-error-html-handler>
                </div>

                <div class="col-50 grid-element" style="margin-top: 20px;">
                  <label class="original-label">
                    <input type="checkbox" name="isDeluxyDotComProduct" formControlName="isDeluxyDotComProduct" (change)="handleShopCheckbox($event, 'deluxyDotCom')">
                    DELUXY DOT COM <b>[deluxy.com]</b>
                  </label>
                </div>
                <div class="col-100 grid-element" [ngClass]="{'hidden': !_productForm.get('isDeluxyDotComProduct').value}" style="margin-top: 20px;">
                  <label for="deluxyDotComDescription">DELUXY DOT COM DESCRIPTION</label>
                  <div [ngxSummernote]="summerNoteConfig" formControlName="deluxyDotComDescription"></div>
                  <app-error-html-handler [ctrl]="_productForm.get('deluxyDotComDescription')" [messages]="formValidationMsgs.deluxyDotComDescription"></app-error-html-handler>
                </div>
              </fieldset>

              <br class="clear">


              <fieldset
                class="shopify-images-box"
                [class.is-disabled]="!canUseShopifyImageUploader()"
              >
                <legend>SHOPIFY PRODUCT IMAGES</legend>

                <div class="shopify-images-header">
                  <div class="shopify-header-icon">
                    <i class="fab fa-shopify"></i>
                  </div>

                  <div class="shopify-header-content">
                    <h3>Product image manager</h3>
                    <p>
                      Upload, arrange and synchronize product images across the selected
                      Shopify stores.
                    </p>
                  </div>

                  <div
                    class="shopify-header-counts"
                    *ngIf="canUseShopifyImageUploader()"
                  >
                    <div class="shopify-count-item">
                      <strong>{{ storedShopifyImages.length }}</strong>
                      <span>Saved</span>
                    </div>

                    <div
                      class="shopify-count-item pending"
                      [class.has-items]="shopifyImageFiles.length > 0"
                    >
                      <strong>{{ shopifyImageFiles.length }}</strong>
                      <span>New</span>
                    </div>
                  </div>
                </div>

                <div
                  class="shopify-images-disabled"
                  *ngIf="!canUseShopifyImageUploader()"
                >
                  <div class="disabled-icon">
                    <i class="fas fa-lock"></i>
                  </div>

                  <div class="disabled-content">
                    <strong>Shopify image manager is currently unavailable</strong>

                    <p>
                      Save and approve this product, then select at least one Shopify store
                      to enable image management.
                    </p>
                  </div>
                </div>

                <ng-container *ngIf="canUseShopifyImageUploader()">
                  <div
                    class="shopify-drop-zone"
                    role="button"
                    tabindex="0"
                    [class.is-dragging]="isDraggingShopifyImages"
                    [class.has-error]="shopifyImageErrors.length > 0"
                    (dragover)="onShopifyImageDragOver($event)"
                    (dragleave)="onShopifyImageDragLeave($event)"
                    (drop)="onShopifyImageDrop($event)"
                    (click)="shopifyImageInput.click()"
                    (keydown.enter)="shopifyImageInput.click()"
                    (keydown.space)="shopifyImageInput.click()"
                  >
                    <input
                      #shopifyImageInput
                      type="file"
                      hidden
                      multiple
                      accept="image/jpeg,image/jpg,image/png,image/webp"
                      (change)="onShopifyImageSelect($event)"
                    />

                    <div class="shopify-drop-icon">
                      <i class="far fa-images"></i>

                      <span
                        class="upload-queue-badge"
                        *ngIf="shopifyImageFiles.length"
                      >
                        {{ shopifyImageFiles.length }}
                      </span>
                    </div>

                    <div class="shopify-drop-copy">
                      <h4>Drop product images here</h4>

                      <p>
                        Drag and drop your images or
                        <span>browse from your device</span>
                      </p>

                      <div class="shopify-upload-requirements">
                        <span>
                          <i class="fas fa-check"></i>
                          JPG, PNG, WEBP
                        </span>

                        <span>
                          <i class="fas fa-check"></i>
                          Maximum 15MB
                        </span>

                        <span>
                          <i class="fas fa-check"></i>
                          Multiple images
                        </span>
                      </div>
                    </div>
                  </div>

                  <div
                    class="shopify-image-errors"
                    *ngIf="shopifyImageErrors.length"
                  >
                    <div class="shopify-error-heading">
                      <i class="fas fa-exclamation-triangle"></i>

                      <div>
                        <strong>
                          {{ shopifyImageErrors.length }}
                          image issue{{ shopifyImageErrors.length === 1 ? '' : 's' }}
                        </strong>

                        <span>Please review the following files.</span>
                      </div>
                    </div>

                    <div
                      class="shopify-image-error"
                      *ngFor="let error of shopifyImageErrors"
                    >
                      {{ error }}
                    </div>
                  </div>

                  <div
                    class="shopify-library-summary"
                    *ngIf="
                      storedShopifyImages.length ||
                      shopifyImageFiles.length
                    "
                  >
                    <div class="library-summary-copy">
                      <i class="fas fa-layer-group"></i>

                      <div>
                        <strong>Image library</strong>

                        <span>
                          {{
                            storedShopifyImages.length +
                            shopifyImageFiles.length
                          }}
                          total image{{
                            storedShopifyImages.length +
                              shopifyImageFiles.length ===
                            1
                              ? ''
                              : 's'
                          }}
                        </span>
                      </div>
                    </div>

                    <div
                      class="primary-image-help"
                      *ngIf="storedShopifyImages.length"
                    >
                      <i class="fas fa-star"></i>
                      The first saved image is used as the primary image.
                    </div>
                  </div>

                  <section
                    class="shopify-image-section"
                    *ngIf="storedShopifyImages.length"
                  >
                    <div class="shopify-section-header">
                      <div>
                        <h4>
                          <i class="fas fa-database"></i>
                          Saved images
                        </h4>

                        <p>
                          These images are currently stored for the product.
                        </p>
                      </div>

                      <span class="section-count">
                        {{ storedShopifyImages.length }}
                      </span>
                    </div>

                    <div class="shopify-image-preview-grid">
                      <article
                        class="shopify-image-preview-card stored-image"
                        *ngFor="
                          let image of storedShopifyImages;
                          let i = index
                        "
                      >
                        <div class="shopify-image-media">
                          <img
                            [src]="image.compressedUrl"
                            [alt]="image.originalName"
                          />

                          <div class="shopify-image-overlay"></div>

                          <span
                            class="primary-badge"
                            *ngIf="i === 0"
                          >
                            <i class="fas fa-star"></i>
                            Primary
                          </span>

                          <span class="image-position-badge">
                            {{ i + 1 }}
                          </span>

                          <button
                            type="button"
                            class="shopify-remove-image"
                            title="Remove saved image"
                            [attr.aria-label]="'Remove ' + image.originalName"
                            (click)="removeStoredShopifyImage(image.id, $event)"
                          >
                            <i class="fas fa-trash-alt"></i>
                          </button>
                        </div>

                        <div class="shopify-image-info">
                          <strong
                            class="shopify-image-name"
                            [title]="image.originalName"
                          >
                            {{ image.originalName }}
                          </strong>

                          <div class="shopify-image-size-list">
                            <span>
                              <i class="fas fa-compress-alt"></i>
                              Optimized:
                              {{ formatFileSize(image.compressedSize) }}
                            </span>

                            <span>
                              <i class="far fa-file-image"></i>
                              Original:
                              {{ formatFileSize(image.originalSize) }}
                            </span>
                          </div>
                        </div>

                        <div class="image-order-container">
                          <span class="order-label">Image position</span>

                          <div class="image-order-actions">
                            <button
                              type="button"
                              title="Move image left"
                              [disabled]="i === 0"
                              (click)="moveStoredShopifyImage(i, -1, $event)"
                            >
                              <i class="fas fa-arrow-left"></i>
                              Earlier
                            </button>

                            <button
                              type="button"
                              title="Move image right"
                              [disabled]="
                                i === storedShopifyImages.length - 1
                              "
                              (click)="moveStoredShopifyImage(i, 1, $event)"
                            >
                              Later
                              <i class="fas fa-arrow-right"></i>
                            </button>
                          </div>
                        </div>

                        <div
                          class="store-status-container"
                          *ngIf="image.stores?.length"
                        >
                          <div class="store-status-heading">
                            <span>Shopify stores</span>
                            <span>{{ image.stores.length }}</span>
                          </div>

                          <div class="store-status-list">
                            <div
                              class="store-status"
                              *ngFor="let store of image.stores"
                              [ngClass]="store.status"
                            >
                              <span class="store-status-dot"></span>

                              <span
                                class="store-name"
                                [title]="getShopDisplayName(store.storeKey)"
                              >
                                {{ getShopDisplayName(store.storeKey) }}
                              </span>

                              <span class="store-status-value">
                                {{ store.status }}
                              </span>

                              <button
                                type="button"
                                *ngIf="store.status === 'failed'"
                                (click)="retryShopifyStore(store.id, $event)"
                              >
                                <i class="fas fa-redo-alt"></i>
                                Retry
                              </button>
                            </div>
                          </div>
                        </div>
                      </article>
                    </div>
                  </section>

                  <section
                    class="shopify-image-section new-images-section"
                    *ngIf="shopifyImageFiles.length"
                  >
                    <div class="shopify-section-header">
                      <div>
                        <h4>
                          <i class="fas fa-cloud-upload-alt"></i>
                          New images
                        </h4>

                        <p>
                          These images will be uploaded when you save the changes.
                        </p>
                      </div>

                      <span class="section-count pending">
                        {{ shopifyImageFiles.length }}
                      </span>
                    </div>

                    <div class="shopify-image-preview-grid">
                      <article
                        class="shopify-image-preview-card new-image"
                        *ngFor="
                          let item of shopifyImageFiles;
                          let i = index
                        "
                      >
                        <div class="shopify-image-media">
                          <img
                            [src]="item.preview"
                            [alt]="item.file.name"
                          />

                          <div class="shopify-image-overlay"></div>

                          <span class="new-badge">
                            <i class="fas fa-plus"></i>
                            New
                          </span>

                          <span class="image-position-badge">
                            {{
                              storedShopifyImages.length +
                              i +
                              1
                            }}
                          </span>

                          <button
                            type="button"
                            class="shopify-remove-image"
                            title="Remove new image"
                            [attr.aria-label]="'Remove ' + item.file.name"
                            (click)="removeNewShopifyImage(i, $event)"
                          >
                            <i class="fas fa-times"></i>
                          </button>
                        </div>

                        <div class="shopify-image-info">
                          <strong
                            class="shopify-image-name"
                            [title]="item.file.name"
                          >
                            {{ item.file.name }}
                          </strong>

                          <div class="shopify-image-size-list">
                            <span>
                              <i class="far fa-file-image"></i>
                              {{ formatFileSize(item.file.size) }}
                            </span>
                          </div>
                        </div>

                        <div class="new-image-status">
                          <span class="status-pulse"></span>

                          <div>
                            <strong>Ready to upload</strong>
                            <span>Not synchronized yet</span>
                          </div>
                        </div>
                      </article>
                    </div>
                  </section>

                  <div
                    class="shopify-empty-library"
                    *ngIf="
                      !storedShopifyImages.length &&
                      !shopifyImageFiles.length
                    "
                  >
                    <div class="empty-library-icon">
                      <i class="far fa-image"></i>
                    </div>

                    <strong>No product images added</strong>

                    <p>
                      Upload the first image using the area above. The first saved image
                      will become the primary product image.
                    </p>
                  </div>

                  <div class="shopify-image-actions">
                    <div class="shopify-action-summary">
                      <ng-container *ngIf="shopifyImageFiles.length">
                        <i class="fas fa-info-circle"></i>

                        <span>
                          {{ shopifyImageFiles.length }}
                          new image{{
                            shopifyImageFiles.length === 1 ? '' : 's'
                          }}
                          waiting to be synchronized.
                        </span>
                      </ng-container>

                      <ng-container
                        *ngIf="
                          !shopifyImageFiles.length &&
                          storedShopifyImages.length
                        "
                      >
                        <i class="fas fa-check-circle"></i>
                        <span>Your saved image library is ready.</span>
                      </ng-container>
                    </div>

                    <div class="shopify-action-buttons">
                      <button
                        type="button"
                        class="btn btn-red shopify-clear-button"
                        [disabled]="
                          !shopifyImageFiles.length ||
                          isShopifyImageUploading
                        "
                        (click)="clearNewShopifyImages($event)"
                      >
                        <i class="far fa-trash-alt"></i>
                        Clear new images
                      </button>

                      <button
                        type="button"
                        class="btn shopify-save-button"
                        [disabled]="isShopifyImageUploading"
                        (click)="syncSelectedProductImagesWithShopify()"
                      >
                        <ng-container *ngIf="!isShopifyImageUploading">
                          <i class="fas fa-sync-alt"></i>
                          Save and synchronize
                        </ng-container>

                        <ng-container *ngIf="isShopifyImageUploading">
                          <i class="fas fa-spinner fa-spin"></i>
                          Synchronizing images...
                        </ng-container>
                      </button>
                    </div>
                  </div>

                  <div
                    class="shopify-result-box"
                    *ngIf="shopifyImageResults.length"
                  >
                    <div class="shopify-result-header">
                      <div>
                        <i class="fas fa-clipboard-check"></i>

                        <div>
                          <strong>Synchronization results</strong>
                          <span>
                            Review the result returned for each image or store.
                          </span>
                        </div>
                      </div>

                      <span class="result-count">
                        {{ shopifyImageResults.length }}
                      </span>
                    </div>

                    <div class="shopify-result-list">
                      <div
                        class="shopify-result-item"
                        *ngFor="let result of shopifyImageResults"
                        [class.success]="result.success"
                        [class.failed]="!result.success"
                      >
                        <div class="result-status-icon">
                          <i
                            class="fas"
                            [ngClass]="
                              result.success
                                ? 'fa-check'
                                : 'fa-exclamation'
                            "
                          ></i>
                        </div>

                        <div class="result-content">
                          <strong>
                            {{
                              result.storeKey ||
                              result.fileName ||
                              result.type
                            }}
                          </strong>

                          <span>{{ result.message }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </ng-container>
              </fieldset>
              
            </fieldset>
          </div>

          <br class="clear">
          <div class="products-partner-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <fieldset>
              <legend>PRODUCTS PARTNER:</legend>
              <div class="col-50 grid-element" *ngIf="(groups.includes('admin') || groups.includes('operation'))" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="visibleToOtherPartners" formControlName="visibleToOtherPartners">
                  Visible To Other Partners
                </label>
              </div> 

              <div class="grid-element-full" [ngClass]="{'hidden': !_productForm.get('visibleToOtherPartners').value}" *ngIf="(groups.includes('admin') || groups.includes('operation'))">
                <label style="position: relative; top: 20px;">PARTNER</label>
                <div formArrayName="productPartners">
                  <div class="offer-products" *ngFor="let productForm of _productForm.get('productPartners').controls; let i = index">
                    <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                      <label for=""></label>
                      <div style="display: table-cell; width: 19px;">
                        <i class="far fa-times-circle hvr-grow remove-product"  (click)="removePartner(i)"></i>
                      </div>
                      <div class="product-q" formGroupName="partner">
                        <div class="porduct-qty">
                          <div class="province-input">
                            <label for=""></label>
                            <ng-select 
                              formControlName="id"
                              [searchable]="true" 
                              [clearable]="true"
                              [virtualScroll]="true"
                            >
                              <ng-option 
                                *ngFor="let partner of partners" 
                                [value]="partner?.id" 
                                [disabled]="isPartnerOptionDisabled(partner)"
                              >
                                {{partner.businessName}}
                              </ng-option>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                      <br>
                      <app-error-html-handler [ctrl]="productForm?.controls?.partner?.controls?.id" [messages]="formValidationMsgs?.productPartners?.partner.id"></app-error-html-handler>
                    </div>
                  </div>
                </div>
                <div class="center" style="width: 100%;">
                  <button class="btn mt-0" (click)="$event.preventDefault(); addPartner()">
                    Aggiungi Partner<i class="ml-10 fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <br class="clear">
          <div class="super-products-box" *ngIf="groups.includes('admin') || groups.includes('operation')">
            <fieldset>
              <legend>SUPER PRODOTTO:</legend>
              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isSuperProduct" formControlName="isSuperProduct">
                  Super Prodotto
                </label>
              </div> 

              <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="isSuperProvinceProduct" formControlName="isSuperProvinceProduct">
                  Super Province
                </label>
              </div> 

              <div class="grid-element-full" [ngClass]="{'hidden': !_productForm.get('isSuperProduct').value}" *ngIf="groups.includes('admin') || groups.includes('operation')">
                <label style="position: relative; top: 20px;">Prodotti</label>
                <div formArrayName="superProducts">
                  <div class="offer-products" *ngFor="let productForm of _productForm.get('superProducts').controls; let i = index">
                    <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                      <label for=""></label>
                      <div style="display: table-cell; width: 19px;">
                        <i class="far fa-times-circle hvr-grow remove-product"  (click)="removeProduct(i)"></i>
                      </div>
                      <div class="product-q" formGroupName="product">
                        <div class="porduct-qty">
                          <div class="province-input">
                            <label for=""></label>
                            <ng-select 
                              formControlName="id"
                              [searchable]="true" 
                              [clearable]="true"
                              [virtualScroll]="true"
                              >
                              <ng-option 
                                *ngFor="let product of products" 
                                [value]="product?.id" 
                                [disabled]="isProductOptionDisabled(product)"
                              >
                                {{product.name}}
                              </ng-option>
                            </ng-select>
                          </div>
                        </div>
                      </div>
                      <br>
                      <app-error-html-handler [ctrl]="productForm?.controls?.product.controls?.id" [messages]="formValidationMsgs?.superProducts?.product.id"></app-error-html-handler>
                    </div>
                  </div>
                </div>
                <div class="center" style="width: 100%;">
                  <button class="btn mt-0" (click)="$event.preventDefault(); addProduct()">
                    Aggiungi Prodotto<i class="ml-10 fas fa-plus"></i>
                  </button>
                </div>
              </div>
            </fieldset>
          </div>

          <br class="clear">
          <div class="products-variant-box" *ngIf="groups.includes('admin') || groups.includes('operation') || groups.includes('partner')">
            <fieldset>
              <legend>PRODOTTO VARIANTI:</legend>

              <div class="col-50 grid-element" style="margin-top: 20px;">
                <label class="original-label">
                  <input type="checkbox" name="productHasVariants" formControlName="productHasVariants" (change)="productHasVariant($event)">
                  Il prodotto ha variant?<b>[{{ _productForm.get('productHasVariants').value ? "SI" : "NO" }}]</b>
                </label>
              </div>

              <br class="clear">
              <div class="col-50 grid-element" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
                <label for="productOptionTitle">Nome Opzione{{ _productForm.get("productOptionTitle") | required }}</label>
                <input type="text" name="productOptionTitle" formControlName="productOptionTitle">
                <app-error-html-handler [ctrl]="_productForm.get('productOptionTitle')" [messages]="formValidationMsgs.productOptionTitle"></app-error-html-handler>
              </div>

              <div formArrayName="productVariants" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
                <div style="margin-top: 20px;" *ngFor="let variant of _productForm.get('productVariants').controls; let i = index">
                  <div [formGroupName]="i" class="" style="display: table; width: 100%;">
                    <fieldset>
                      <div class="col-50 grid-element">
                        <label for="variantName">Nome VARIANTI{{ variant.get("variantName") | required }}</label>
                        <input type="text" name="variantName" formControlName="variantName">
                        <app-error-html-handler [ctrl]="variant.get('variantName')" [messages]="formValidationMsgs.productVariants.variantName"></app-error-html-handler>
                      </div>
              
                      <div class="col-50 grid-element">
                        <label for="variantSku">VARIANTI SKU{{ variant.get("variantSku") | required }}</label>
                        <input type="text" name="variantSku" formControlName="variantSku">
                        <app-error-html-handler [ctrl]="variant.get('variantSku')" [messages]="formValidationMsgs.productVariants.variantSku"></app-error-html-handler>
                      </div>
          
                      <div class="col-50 grid-element">
                        <label for="variantGgDispMin">VARIANTI Giorni Preparazione{{ variant.get("variantGgDispMin") | required }}</label>
                        <input type="number" min="0" name="variantGgDispMin" formControlName="variantGgDispMin">
                        <app-error-html-handler [ctrl]="variant.get('variantGgDispMin')" [messages]="formValidationMsgs.productVariants.variantGgDispMin"></app-error-html-handler>
                      </div>
              
                      <div class="col-50 grid-element">
                        <label for="variantPrice">VARIANTI PREZZO{{ variant.get("variantPrice") | required }}</label>
                        <input type="number" min="0" name="variantPrice" formControlName="variantPrice">
                        <app-error-html-handler [ctrl]="variant.get('variantPrice')" [messages]="formValidationMsgs.productVariants.variantPrice"></app-error-html-handler>
                      </div>

                      <div class="col-50 grid-element" *ngIf="groups.includes('admin') || groups.includes('operation')">
                        <label for="variantShopifyPrice">VARIANTI PREZZO PUBLICO{{ variant.get("variantShopifyPrice") | required }}</label>
                        <input type="number" min="0" name="variantShopifyPrice" formControlName="variantShopifyPrice">
                        <app-error-html-handler [ctrl]="variant.get('variantShopifyPrice')" [messages]="formValidationMsgs.productVariants.variantShopifyPrice"></app-error-html-handler>
                      </div>

                      <!-- <fieldset style="margin-top: 20px;" *ngIf="groups.includes('admin') || groups.includes('operation')"> -->
                      <fieldset style="margin-top: 20px;">
                        <legend>INVENTORY MANAGEMENT(VARIANTI)</legend>

                        <div class="col-50 grid-element">
                          <label class="original-label" for="controlVariantStock_{{i}}">
                            <input type="checkbox" name="controlVariantStock" id="controlVariantStock_{{i}}" formControlName="controlVariantStock">
                            CONTROLLA STOCK(VARIANTI)
                          </label>
                        </div> 

                        <br class="clear">

                        <div class="col-50 grid-element" *ngIf="variant.get('controlVariantStock').value === true" style="margin-top: 20px;">
                          <label for="variantAvailability">VARIANTI INVENTARIO{{ variant.get("variantAvailability") | required }}</label>
                          <input type="number" name="variantAvailability" formControlName="variantAvailability">
                          <app-error-html-handler [ctrl]="variant.get('variantAvailability')" [messages]="formValidationMsgs.productVariants.variantAvailability"></app-error-html-handler>
                        </div>
                      </fieldset>

                      <!--
                      <div class="col-50 grid-element" style="margin-top: 20px;">
                        <label class="original-label">
                          <input type="checkbox" name="variantInStock" formControlName="variantInStock">
                          DISPONIBILE(VARIANTI)
                        </label>
                      </div>
                      -->

                      <div class="center" style="width: 100%; margin-top: 20px;">
                        <button class="btn mt-5 btn-red hvr-grow mr-10" (click)="$event.preventDefault(); removeProductVariant(i)">
                          Rimuovi<i class="ml-10 far fa-trash-alt"></i>
                        </button>
                      </div>
                    </fieldset>
                  </div>
                </div>
              </div>
              <div class="center" style="width: 100%; margin-top: 20px;" [ngClass]="{'hidden': !_productForm.get('productHasVariants').value}">
                <button class="btn mt-5" (click)="$event.preventDefault(); addProductVariant()">
                  Aggiungi Varianti<i class="ml-10 fas fa-plus"></i>
                </button>
              </div>
            </fieldset>
          </div>

          <div class="center" style="margin-top: 10px;">
            <button class="btn hvr-shrink center" (click)="$event.preventDefault(); onSubmit()" [disabled]="!_productForm?.valid || tmpBtnDisabled">
              Salva<i class="ml-10 far fa-save"></i>
            </button>
            &nbsp;
            <button type="button" class="btn hvr-shrink center" [routerLink]="['/product/duplica', product?.id]" *ngIf="product?.id && (groups.includes('admin') || groups.includes('operation'))">
              Duplica<i class="ml-10 far fa-save"></i>
            </button>
          </div>

          <div class="error-box" style="margin-top: 15px;" *ngIf="getErrorMessages().length > 0">
            <fieldset>
              <legend>CAMPI OBBLIGATORI:</legend>
              <div>
                <ul class="error-list">
                  <li *ngFor="let error of getErrorMessages()">
                    {{ translateErrorMessage(error) }}
                  </li>
                </ul>
              </div>
            </fieldset>
          </div>
        </form>
        <br class="clear">
      </div>
    </section>
  </div>
</section>


